import classNames from 'classnames';
import React, { useEffect, useState } from 'react';

import { BotsGrey, Clock, DashBoard, ImageOutline, Narration, Reply } from '@/components/icon';
import { ISwitchGroup } from '@/interface/gamePlay';
import { isWoa } from '@/utils/getApiDomain';

import styles from './index.module.less';

interface IProps {
  disabled?: boolean;
  value: ISwitchGroup;
  onChange: (val: ISwitchGroup) => void;
}

const switchFields = [
  {
    key: 'guideReply', label: '灵感回复', icon: <Reply />,
    desc: '为用户生成不同性格的回复灵感',
    show: true,
    allowEdit: false,
  },
  {
    key: 'botGroupChat', label: '群聊', icon: <BotsGrey />,
    desc: '用户可与多个角色对话',
    show: true,
    allowEdit: false,
  },
  {
    key: 'narration', label: '情节续写', icon: <Narration />,
    desc: '智能扩写剧情，推动故事发展',
    show: true,
    allowEdit: false,
  },
  {
    key: 'numSys', label: '数值系统', icon: <DashBoard />,
    desc: '设置数值名称及增减规则',
    show: true,
    allowEdit: false,
  },
  {
    key: 'countDown', label: '倒计时', icon: <Clock />,
    desc: '设置过关时限',
    show: true,
    allowEdit: false,
  },
  // 仅 WOA平台可配置，不受disabled状态影响
  {
    key: 'sendImage', label: '发送图片', icon: <ImageOutline />,
    desc: '玩家可以发送图片，角色可回复图片',
    show: isWoa,
    allowEdit: isWoa,
  },
] as const;

export type GameSwitchField = typeof switchFields[number]['key'];

export const SwitchGroup: React.FC<IProps> = (props) => {
  const {
    disabled = false,
    value = {},
    onChange,
  } = props;
  const [switchs, setSwitchs] = useState(value);

  useEffect(() => {
    setSwitchs(value);
  }, [JSON.stringify(value)]);

  const handleClick = (key: GameSwitchField) => {
    const newValue = { ...switchs, [key]: !switchs[key] };
    setSwitchs(newValue);
    onChange(newValue);
  };

  return (
    <div className={styles.container}>
      {switchFields.map(({ key, label, icon, show, allowEdit }) => {
        const isOpen = switchs[key];
        return show ? (
          <div key={key} className={classNames(
            styles.switch,
            {
              [styles.activeSwitch]: isOpen,
              [styles.disabled]: (disabled && !allowEdit),
            },
          )}
            onClick={() => !(disabled && !allowEdit) && handleClick(key)}>
            <div className={styles.header}>
              <div className={classNames(styles.title, { [styles.activeTitle]: isOpen })}>
                {icon}
                {label}
              </div>
              <div className={classNames(styles.status, { [styles.activeStatus]: isOpen })}>
                {isOpen ? '已开启' : '未开启'}
              </div>
            </div>
            {/* <div className={classNames(styles.desc, { [styles.activeDesc]: isOpen })}>
              {desc}
            </div> */}
          </div>
        ) : <div key={key}></div>;
      })}
    </div>
  );
};
